import { render, staticRenderFns } from "./ExpressUpload.vue?vue&type=template&id=168e4b04"
import script from "./ExpressUpload.vue?vue&type=script&lang=js"
export * from "./ExpressUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports